module.exports = __webpack_public_path__ + "static/media/stand_alimentation.ab38258f.jpg";